import {
  RecognitionSection,
  RecognitionSectionProps,
} from '@exploration/shared-sections';
import { desktop } from '@thrivent/midwest-shared';
import styled from 'styled-components';

const StyledRecognitionSection = styled(RecognitionSection)`
  padding-block: 2.5rem 3rem;
  background-color: ${(p) => p.theme.midwestColors.backgroundSecondary};
  ${desktop} {
    padding-block: 5rem;
  }
`;
export const AdvicePageRecognitionSection = (
  props: RecognitionSectionProps,
) => {
  return <StyledRecognitionSection {...props} />;
};

export default AdvicePageRecognitionSection;
